import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import type { Color } from "@msuite/utils/colors";
import type { IncomingEmailListItem } from "@msuite/utils/types";

/** Props Interface */
interface IncomingEmailProcessingStateTagProps {
	processingState: IncomingEmailListItem["processingState"];
}

const PROCESSING_STATE_COLOR: Record<IncomingEmailListItem["processingState"], Color> = {
	queued: "gray",
	started: "blue",
	completed: "emerald",
	skipped: "amber",
	failed: "rose",
};

export function IncomingEmailProcessingStateTag({
	processingState,
}: IncomingEmailProcessingStateTagProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	// Pinned inside the cell like the attachments column, so the tag never sets the row's height.
	return (
		<div className="absolute inset-y-0 inset-x-2 h-stack items-center">
			<Tag
				size="xs"
				color={PROCESSING_STATE_COLOR[processingState]}
				variant="plain"
			>
				{t(`mailboxes.processing_state.${processingState}`)}
			</Tag>
		</div>
	);
}
